import { connect } from 'react-redux';
import actions from '../../actions/index';
import MoveCandidatesModal from '../components/MoveCandidatesModal/MoveCandidatesModal';

const mapStateToProps = (state) => ({
  moveDestinations: state.campaigns.moveDestinations,
  moveDestinationsStatus: state.campaigns.moveDestinationsStatus,
  moveDestinationsError: state.campaigns.moveDestinationsError,
  movePreview: state.campaigns.movePreview,
  movePreviewStatus: state.campaigns.movePreviewStatus,
  movePreviewError: state.campaigns.movePreviewError,
  moveResult: state.campaigns.moveResult,
  moveCandidatesStatus: state.campaigns.moveCandidatesStatus,
  moveCandidatesError: state.campaigns.moveCandidatesError,
});

const mapDispatchToProps = (dispatch) => ({
  getMoveDestinations: (sourceCampaignId, search) =>
    dispatch(actions.campaigns.getMoveDestinations(sourceCampaignId, search)),
  getMovePreview: (sourceCampaignId, destinationCampaignId) =>
    dispatch(
      actions.campaigns.getMovePreview(sourceCampaignId, destinationCampaignId),
    ),
  moveCandidates: (sourceCampaignId, destinationCampaignId, invitationIds) =>
    dispatch(
      actions.campaigns.moveCandidates(
        sourceCampaignId,
        destinationCampaignId,
        invitationIds,
      ),
    ),
  resetMoveFlow: () => dispatch(actions.campaigns.resetMoveFlow()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MoveCandidatesModal);
